exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._10-fPxz4_M-U3FzwzEUKwK{width:100%;min-width:0;height:40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] ._10-fPxz4_M-U3FzwzEUKwK{background-color:\"[theme:white, default:#ffffff]\";border-bottom:1px solid \"[theme:neutralLighter, default:#f3f2f1]\";padding:0 16px}._2EeghDozsP3UuxXCDzcRbR{height:100%}", ""]);
// Exports
exports.locals = {
	"chatContact": "_10-fPxz4_M-U3FzwzEUKwK",
	"persona": "_2EeghDozsP3UuxXCDzcRbR"
};